<template>
    <footer class="footer">
        <p class="copyRight">Copyright ⓒ e-CLUB 전자사랑모임. All Rights Reserved.</p>
<!--        <p class="copyRight">Copyright © www.dangamsoft.com All rights reserved.</p>-->
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style lang="scss" scoped>
    .footer{
        padding: 20px 0;
        border-top: 1px solid #efefef;
        .copyRight{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #666;
        }
    }

</style>